/* eslint-disable import/prefer-default-export */
/**
 * Calculates the backoff delay for WebSocket reconnection attempts.
 * For the first attempt (retryCount 0) the delay is 0ms (connect immediately).
 * For subsequent attempts, uses an exponential schedule of (2^retryCount - 1) * 1000ms,
 * capped at 60000ms. Examples: 1→1000ms, 2→3000ms, 3→7000ms, 4→15000ms, 5→31000ms, 6+→60000ms.
 *
 * @param retryCount - The number of previous retry attempts (0-based)
 * @returns The delay in milliseconds before the next retry attempt
 */
export const disconnectBackoff = (
  retryCount: number,
): number => (
  retryCount
    ? Math.min(1000 * (2 ** (retryCount - 2)), 60000)
    : 0
);
